import client from "../client/client";

// Consume el endpoint de uso de egresos del mes vs el cupo del plan.
// Respuesta: { plan, used, limit, remaining, status }
//   status: "ok" | "warning" | "blocked" | "unlimited" | "unknown"
const getEgresoUsage = async (userId) => {
  const id = userId ?? parseInt(sessionStorage.getItem("User"), 10);
  const resp = await client.get(`/warehouse-api/movement/usage/${id}`);
  return resp?.data;
};

const usageService = {
  getEgresoUsage,
};

export default usageService;
